import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from './../../Services/session.service';

import { AppSettings } from '../../app-settings';


@Component({
  selector: "app-activity-attempts",
  templateUrl: "./activity-attempts.component.html",
  styleUrls: ["./activity-attempts.component.css"],
})
export class ActivityAttemptsComponent implements OnInit {
  @Input() attempts = [];
  @Input() activityId;
  @Input() isGraded;
  sortInAscending = true;
  sortBasedOnColumn = "Attempt Number";
  activityPlayBtnIconAssetURL: string =
    AppSettings.cdnUrl + "assets/images/Start_activity.svg";
  noDataAvailableIconURL =
    AppSettings.cdnUrl + "assets/images/no_data_icon.png";
  attemptAgainIconURL =
    AppSettings.cdnUrl + "assets/images/Replay_activity.svg";
  pageName;

  constructor(
    private sessionService: SessionService,
    private router: Router
  ) {}

  ngOnInit() {
    this.attempts = this.sortAttemptsArray(
      this.attempts,
      this.sortBasedOnColumn,
      true
    );
    this.clearOpacityOne("opacity_one");
    this.sessionService.getPageName.subscribe(
      (pageName) => (this.pageName = pageName)
    );
  }

  getSortedAttemptsArray(eventTarget) {
    let downArrow;
    let upArrow;
    let tableHeader = eventTarget.textContent ? eventTarget.textContent : eventTarget.parentElement.textContent;
    if (eventTarget.children.length > 0) {
      upArrow = eventTarget.children[1];
      downArrow = eventTarget.children[0];
    } else {
      upArrow = eventTarget.parentElement.children[1];
      downArrow = eventTarget.parentElement.children[0];
    }
    this.sortInAscending =
      this.sortBasedOnColumn === tableHeader ? !this.sortInAscending : true;
    this.sortBasedOnColumn = tableHeader;
    this.changeArrowOpacity(upArrow, downArrow);
    this.attempts = this.sortAttemptsArray(
      this.attempts,
      tableHeader,
      this.sortInAscending
    );
  }

  changeArrowOpacity(upArrow: HTMLElement, downArrow: HTMLElement) {
    if (upArrow.classList.contains("opacity_one")) {
      this.clearOpacityOne("opacity_one");
      downArrow.classList.add("opacity_one");
    } else if (downArrow.classList.contains("opacity_one")) {
      this.clearOpacityOne("opacity_one");
      upArrow.classList.add("opacity_one");
    } else {
      this.clearOpacityOne("opacity_one");
      upArrow.classList.add("opacity_one");
    }
  }

  clearOpacityOne(className) {
    let elements = document.getElementsByClassName(className);
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.remove(className);
    }
  }

  sortAttemptsArray(arr, tableHeader, isAscending) {
    let sortedArray;
    let tableHeaderConfig = {
      "Attempt Time": "timestamp",
      "Attempt Number": "attemptNumber",
      Score: "percentage",
    };
    if (tableHeader === "Attempt Time") {
      sortedArray = arr.sort((a, b) =>
        this.sortFunction(
          new Date(a[tableHeaderConfig[tableHeader]]).getTime(),
          new Date(b[tableHeaderConfig[tableHeader]]).getTime(),
          isAscending
        )
      );
    } else {
      sortedArray = arr.sort((a, b) =>
        this.sortFunction(
          a[tableHeaderConfig[tableHeader]],
          b[tableHeaderConfig[tableHeader]],
          isAscending
        )
      );
    }
    return sortedArray;

  }

  sortFunction(a, b, isAscending) {
    return isAscending ? a - b : b - a;
  }

  routeTo() {
    this.router.navigate([
      "/journey",
      "page",
      this.pageName,
      "activity",
      this.activityId,
    ]);
  }
}
